module.exports = __webpack_public_path__ + "img/link-banner-it.f86d4544.png";